/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountUnderReviewPeriod,
  CreateAccountUnderReviewPeriodRequest,
  CreateAccountUnderReviewPeriodResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get under review periods for an account.
 */
export const getAccountUnderReviewPeriods = (
  billingAccountId: number,
  options?: SecondParameter<
    typeof backofficeRequest<AccountUnderReviewPeriod[]>
  >,
) => {
  return backofficeRequest<AccountUnderReviewPeriod[]>(
    {
      url: `/api/v1/accounts/${billingAccountId}/under_review_periods`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Create an under review period for an account.
 */
export const createAccountUnderReviewPeriod = (
  billingAccountId: number,
  createAccountUnderReviewPeriodRequest: CreateAccountUnderReviewPeriodRequest,
  options?: SecondParameter<
    typeof backofficeRequest<CreateAccountUnderReviewPeriodResponse>
  >,
) => {
  return backofficeRequest<CreateAccountUnderReviewPeriodResponse>(
    {
      url: `/api/v1/accounts/${billingAccountId}/under_review_periods`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAccountUnderReviewPeriodRequest,
    },
    options,
  )
}
/**
 * @summary Cancel an under review period for an account.
 */
export const cancelAccountUnderReviewPeriod = (
  billingAccountId: number,
  reviewPeriodId: number,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/api/v1/accounts/${billingAccountId}/under_review_periods/${reviewPeriodId}`,
      method: "DELETE",
    },
    options,
  )
}
export type GetAccountUnderReviewPeriodsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountUnderReviewPeriods>>
>
export type CreateAccountUnderReviewPeriodResult = NonNullable<
  Awaited<ReturnType<typeof createAccountUnderReviewPeriod>>
>
export type CancelAccountUnderReviewPeriodResult = NonNullable<
  Awaited<ReturnType<typeof cancelAccountUnderReviewPeriod>>
>
